import React, { useEffect, useState } from 'react'

import {
    Link,
    Navigate
} from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";

const Main = ({ }) => {

    const dispatch = useDispatch();

    const { currentUser } = useSelector((state) => state.auth);


    if (currentUser && currentUser?.token) {
        return (<><Navigate to="/home" replace /></>)
    } else {
        return (<><Navigate to="/login" replace /></>)
    }
}
export default Main;
